// services/scannerApi.js

import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASEURL || 'http://localhost:3005';

const authHeader = () => ({
  Authorization: localStorage.getItem('token'),
});

// ─── Helpers ──────────────────────────────────────────────────────────────────

function parseTradeInfo(raw) {
  if (raw == null) return {};
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'string') {
    try { return JSON.parse(raw); } catch { return {}; }
  }
  return {};
}


// ─── Scanner Profiles ─────────────────────────────────────────────────────────

const scannerProfiles = {

  async list() {
    const { data } = await axios.get(`${API_BASE}/api/trading_bots`, {
      params: { status: 'scanner_profile' },
      headers: authHeader(),
    });
    return data || [];
  },

  async get(id) {
    const { data } = await axios.get(`${API_BASE}/api/trading_bots/${id}`, {
      headers: authHeader(),
    });
    return data;
  },

  async create(payload) {
    const { data } = await axios.post(`${API_BASE}/api/trading_bots`, payload, {
      headers: authHeader(),
    });
    return data;
  },

  async update(id, payload) {
    const { data } = await axios.put(`${API_BASE}/api/trading_bots/${id}`, payload, {
      headers: authHeader(),
    });
    return data;
  },

  async toggle(id) {
    const { data } = await axios.post(
      `${API_BASE}/api/trading_bots/${id}/toggle_scanner`,
      null,
      { headers: authHeader() }
    );
    return data;
  },

  async remove(id) {
    const { data } = await axios.delete(`${API_BASE}/api/trading_bots/${id}`, {
      headers: authHeader(),
    });
    return data;
  },

  async spawned(profileId, limit = 50) {
    const { data } = await axios.get(`${API_BASE}/api/trading_bots`, {
      params: { spawned_from: profileId, limit },
      headers: authHeader(),
    });
    return data || [];
  },

  async metrics(id) {
    try {
      const { data } = await axios.get(
        `${API_BASE}/api/trading_bots/${id}/scanner_metrics`,
        { headers: authHeader() }
      );
      return data;
    } catch (err) {
      if (err?.response?.status === 404) return null;
      throw err;
    }
  },
};


// ─── Universe ─────────────────────────────────────────────────────────────────

const universe = {
  /**
   * Preview which symbols a universe filter resolves to.
   * Used by the scanner form's live preview.
   *
   * @param {Object} filter - {
   *   type: 'top_volume' | 'list' | 'category',
   *   exchange?: string,         // 'binance.com' (defaults server-side)
   *   exchange_id?: number,      // alternative to exchange name
   *   market_type?: 'spot',
   *   limit?: number,
   *   quote?: string,            // 'USDT'
   *   min_volume?: number,
   *   symbols?: string[],
   *   category?: string,
   *   fee_filter?: 'any' | 'zero_maker' | 'zero_taker' | 'zero_either' | 'zero_both',
   *   blacklist?: string[],
   * }
   * @returns {Promise<{count: number, symbols: Array<{symbol, base_asset, quote_asset, ...}>}>}
   */
  async preview(filter) {
    const { data } = await axios.post(
      `${API_BASE}/api/scanner/universe/preview`,
      filter,
      { headers: authHeader() }
    );
    return data;
  },
};


export default { scannerProfiles, universe };